module.exports = __webpack_public_path__ + "img/nbus_box_object_1.e28048cb.png";